import { action } from 'typesafe-actions';
import { Constants } from './commonTypes';
import { LoginMdl } from '../../Modal/Login';
import RequestManager from '../../API';
import api from "../../utils/api";
import { storeLoginStatus, storeSession } from '../users/userActions';
import { CartDetailShow } from '../products/productsAsyncActions';
import { storeCartDetails } from '../products/productsActions';


export const loginResponse = (loginObj: LoginMdl) => async (dispatch: any) => {
  const response: any = await RequestManager.postRequest(dispatch, api.POST_LOGIN, "", loginObj)
  if (response) {
    const Qparams: any = `?customerId=${response?.data[0]?.userId}`;
    const cartData: any = await dispatch(CartDetailShow(Qparams));
    dispatch(storeCartDetails(cartData?.data?.[0]));
    dispatch(storeLoginStatus(true));
    dispatch(storeSession(response.data[0]));
    dispatch(setLoading(false))
    return response?.data[0]
  }
};

export const resetStore = () => {
  return action(
    Constants.RESET_STORE
  )
}
export function storeGetCustomer(payload: any) {

  return action(
    Constants.SET_CUSTOMERDATA, {
    customerData: payload
  })
}
export function setLoading(loading: boolean = true) {
  return action(
    Constants.SET_LOADING, {
    loading
  });
}
export function setFilterLoading(FilterLoading: boolean = true) {
  return action(
    Constants.SET_FILTERED_LOADING, {
    FilterLoading
  });
}